import createIcon from '../../createIcon';

/**
 * @component @name DonutLarge
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNS4wOFYyQzYgMi41IDIgNi44MSAyIDEyQzIgMTcuMTkgNiAyMS41IDExIDIyVjE4LjkyQzggMTguNDQgNSAxNS41MiA1IDEyQzUgOC40OCA4IDUuNTYgMTEgNS4wOFpNMTguOTcgMTFIMjJDMjEuNTMgNiAxOCAyLjQ3IDEzIDJWNS4wOEMxNiA1LjUxIDE4LjU0IDggMTguOTcgMTFaTTEzIDE4LjkyVjIyQzE4IDIxLjUzIDIxLjUzIDE4IDIyIDEzSDE4Ljk3QzE4LjU0IDE2IDE2IDE4LjQ5IDEzIDE4LjkyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DonutLarge = createIcon('DonutLarge', [
  [
    'path',
    {
      d: 'M11 5.08V2C6 2.5 2 6.81 2 12C2 17.19 6 21.5 11 22V18.92C8 18.44 5 15.52 5 12C5 8.48 8 5.56 11 5.08ZM18.97 11H22C21.53 6 18 2.47 13 2V5.08C16 5.51 18.54 8 18.97 11ZM13 18.92V22C18 21.53 21.53 18 22 13H18.97C18.54 16 16 18.49 13 18.92Z',
      key: '2zl8cr',
    },
  ],
]);

export default DonutLarge;
